module.exports = __webpack_public_path__ + "static/media/heart2019.c848afc7.jpg";